import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_MONITORING_QUEUE_ENTRIES } from "../types";
import { MONITORING_QUEUE_ENTRY_MESSAGES } from "../constants/monitoringQueueEntryMessages";
import {
  getMonitoringQueueEntriesPending,
  getMonitoringQueueEntriesFulfilled,
  getMonitoringQueueEntriesRejected,
  setNoEntriesMessage,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import { filtersSelector } from "../selectors";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "monitoringqueueentry/get",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? setNoEntriesMessage(MONITORING_QUEUE_ENTRY_MESSAGES.NOT_FOUND)
        : getMonitoringQueueEntriesFulfilled(response),
  ],
  onError: [
    getMonitoringQueueEntriesRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getMonitoringQueueEntriesEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_MONITORING_QUEUE_ENTRIES.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = filtersSelector(state$.value);
      return merge(
        of(getMonitoringQueueEntriesPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getMonitoringQueueEntriesEpic$;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/getMonitoringQueueEntriesEpic.js